const messages = {
  title: "За BS Plus",
  description: "About page description",
};

export default {
  messages,
};
